<script lang="ts">
    import {pipe} from '../../../svelte/utils';
    import {loc} from '../../../svelte/pipes';
    import {isNullOrUndefined} from '../../../shared/utils/custom-utils';

    export let option: any;
</script>

<template>
    {pipe(option, loc())}
    {#if !isNullOrUndefined(option.count)}
        <span class="text-muted">{option.count}x</span>
    {/if}
</template>